module.exports = __webpack_public_path__ + "static/media/buffet11.527ed1ca.jpg";